<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"> </ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<div class="app-content content">
	<div class="content-wrapper">
		<div class="content-header row mb-1"></div>
		<div class="content-detached">
			<div class="content-body">
				<!--BARRA DE BUSQUEDA-->
				<app-search-bar [criterioPrincipal]="configLocal.barraBusqueda.criterioPrincipal" [config]="configLocal.barraBusqueda" [registroActivacion]="true" [useAccordionMode]="true" [useInlineDeactivatedCheckbox]="true" [useInlineSearchButton]="true" (busqueda)="searchElementsByFilter($event)"></app-search-bar>
				<section class="row">
					<div class="col-12">
						<div class="card card-custom">
							<div class="card-header">
								<h4 class="card-title">Clientes</h4>
								<div class="card-toolbar"></div>
							</div>
							<div class="card-head">
								<div class="heading-elements mt-0">
									<button class="buttonMantenedor btn btn-warning float-right mr-5 mt-5 btn-export" (click)="exportToExcel()" data-gtm-id="exportar" data-gtm-group="clientes-nacionales" *ngIf="permissions.getPermission('30-20-12').asignado" ngbTooltip="Utilice el filtro de búsqueda para acotar el rango a exportar">
										<i class="flaticon-download-1"></i>
										Exportar
									</button>
									<button class="buttonMantenedor btn btn-success float-right mr-5 mt-5" (click)="openCreateClientModal(createClientModal)" data-gtm-id="ingresar" data-gtm-group="clientes-nacionales" *ngIf="permissions.getPermission('30-20-10').asignado">
										<i class="flaticon-add-circular-button"></i>
										Ingresar Cliente
									</button>
								</div>
							</div>
							<!-- <div class="col-1" >
                                <ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change) ="setPageSize()">
                                   <option *ngFor="let option of page.pageSizes" [value]="option" ></option>
                                </ng-select>
                           </div> -->
							<div class="card-content">
								<div class="card-body">
									<ngx-datatable
										#table
										class="material rows contacts-table mobile-hidden"
										[rows]="rowsMantenedor"
										[columnMode]="'flex'"
										[headerHeight]="50"
										[footerHeight]="50"
										[rowHeight]="80"
										fxFlex="auto"
										[perfectScrollbar]="configScroll"
										[externalPaging]="true"
										[count]="page.totalElements"
										[offset]="page.pageNumber"
										[limit]="page.pageSize"
										(page)="setPage($event)"
										(sort)="utilities.onSortTable(table, page)"
										[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }"
										[externalSorting]="false"
										[sortType]="SortType.multi"
									>
										<ngx-datatable-column name="rutString" [flexGrow]="3" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="date-table-alignment">Rut</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="date-table-alignment">{{ row.rutString }}</span></ng-template
											>
										</ngx-datatable-column>

										<ngx-datatable-column name="razonSocial" [flexGrow]="4" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Razón Social</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment text-wrap">{{ row.razonSocial }}</span>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-column name="correo" [flexGrow]="5.5" [sortable]="false" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Correo Facturación</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.correoFact }}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column name="direccion" [flexGrow]="3.5" [sortable]="false" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Dirección</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment text-wrap">{{ row.dirFact }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="ciudad" [flexGrow]="3" [sortable]="false" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Ciudad</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.ciudad }}</span></ng-template
											>
										</ngx-datatable-column>

										<ngx-datatable-column name="Acciones" [flexGrow]="4" [sortable]="false" [resizeable]="false">
											<ng-template ngx-datatable-cell-template let-row="row">
												<a class="primary edit mr-1 mrless" ngbTooltip="Detalles Cliente" id="mantenedor-clientes.component_Detalles_Cliente" (click)="openDetailsClient(clientDetailModal, row)" *ngIf="permissions.getPermission('30-20-20').asignado">
													<div class="icon-circle bg-warning text-center align-middle pt-info-button">
														<fa-icon icon="info-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a class="primary edit mr-1 mrless" ngbTooltip="Editar Cliente" id="mantenedor-clientes.component_Editar_Cliente" (click)="openEditClientModal(editClientModal, row)" *ngIf="permissions.getPermission('30-20-14').asignado">
													<div class="icon-circle bg-info text-center align-middle pt-info-button">
														<fa-icon icon="pencil-alt" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a
													*ngIf="row.activo && permissions.getPermission('30-20-22').asignado"
													class="danger edit mr-1 mrless"
													ngbTooltip="Desactivar Cliente"
													[swal]="{
														title: 'Confirmación',
														text: '¿Está seguro de desactivar este cliente?',
														confirmButtonText: 'Desactivar',
														cancelButtonText: 'Cancelar',
														showCancelButton: true,
														confirmButtonColor: '#F64E60'
													}"
													(confirm)="deactivateClient(row)"
												>
													<div class="icon-circle bg-danger text-center align-middle pt-info-button">
														<fa-icon icon="times-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a
													*ngIf="!row.activo && permissions.getPermission('30-20-24').asignado"
													class="danger edit mr-1 mrless"
													ngbTooltip="Reactivar cliente"
													[swal]="{
														title: 'Confirmación',
														text: '¿Está seguro de reactivar este cliente?',
														confirmButtonText: 'Reactivar',
														cancelButtonText: 'Cancelar',
														showCancelButton: true,
														confirmButtonColor: '#1BC5BD'
													}"
													(confirm)="reactivateClient(row)"
												>
													<div class="icon-circle bg-success text-center align-middle pt-info-button">
														<fa-icon icon="check-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a [routerLink]="" container="body" ngbTooltip="Detalle Documentos" class="primary edit mr-1 mrless" (click)="relatedDtes(row)" *ngIf="permissions.getPermission('30-20-26').asignado">
													<div class="icon-circle bg-info text-center align-middle pt-info-button">
														<fa-icon icon="book" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
												<div class="col-auto">Elementos por página</div>
												<div class="mr-5">
													<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible" appendTo="datatable-footer">
														<option *ngFor="let option of page.pageSizes" [value]="option"></option>
													</ng-select>
												</div>
												<div class="ml-5 col-auto divisor-footer">
													<div class="page-count">{{ rowCount | number:'1.0-0':'es-CL' }} Elementos totales</div>
												</div>
												<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="table.onFooterPage($event)"> </datatable-pager>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>

									<!-- seccion tabla mobile-->
									<ngx-datatable
										#tableMobile
										*ngIf="componentStarted"
										class="material desktop-hidden"
										[rows]="rowsMantenedor"
										[columnMode]="'flex'"
										[headerHeight]="50"
										[footerHeight]="70"
										[rowHeight]="70"
										fxFlex="auto"
										[externalPaging]="true"
										[count]="page.totalElements"
										[offset]="page.pageNumber"
										[limit]="page.pageSize"
										(page)="setPage($event)"
										[scrollbarH]="true"
										[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }"
									>
										<!-- Row Detail Template -->
										<ngx-datatable-row-detail [rowHeight]="70" #myDetailRow>
											<ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
												<div class="text-wrap">Rut: {{ row.rutString }} , Correo Facturación: {{ row.correoFact }} , Dirección: {{ row.dirFact }} , Ciudad: {{ row.ciudad }}</div>
											</ng-template>
										</ngx-datatable-row-detail>
										<ngx-datatable-column [width]="30" [resizeable]="false" [sortable]="false" [draggable]="false" [canAutoResize]="false">
											<ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
												<a [class.datatable-icon-right]="!expanded" [class.datatable-icon-down]="expanded" title="Expand/Collapse Row" (click)="toggleExpandRow(row)" class="desktop-hidden"> </a>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="Razón Social" [flexGrow]="5.5" [sortable]="false" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Razón Social</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.razonSocial }}</span>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-column name="Acciones" [flexGrow]="4" [sortable]="false" [resizeable]="false">
											<ng-template ngx-datatable-cell-template let-row="row">
												<div class="action-container">
													<div class="main-action-button" (click)="toggleActions(row)" *ngIf="!row.showActions">
														<fa-icon [icon]="row.showActions ? 'minus' : 'list'"></fa-icon>
													</div>

													<div class="action-buttons action-buttons-client" [ngClass]="{ show: row.showActions }">
														<a class="primary edit mr-1 mrless" ngbTooltip="Detalles Cliente" id="mantenedor-clientes.component_Detalles_Cliente" (click)="openDetailsClient(clientDetailModal, row)" *ngIf="permissions.getPermission('30-20-20').asignado">
															<div class="icon-circle bg-warning text-center align-middle pt-info-button">
																<fa-icon icon="info-circle" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
														<a class="primary edit mr-1 mrless" ngbTooltip="Editar Cliente" id="mantenedor-clientes.component_Editar_Cliente" (click)="openEditClientModal(editClientModal, row)" *ngIf="permissions.getPermission('30-20-14').asignado">
															<div class="icon-circle bg-info text-center align-middle pt-info-button">
																<fa-icon icon="pencil-alt" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
														<a
															*ngIf="row.activo && permissions.getPermission('30-20-22').asignado"
															class="danger edit mr-1 mrless"
															ngbTooltip="Desactivar Cliente"
															[swal]="{
																title: 'Confirmación',
																text: '¿Está seguro de desactivar este cliente?',
																confirmButtonText: 'Desactivar',
																cancelButtonText: 'Cancelar',
																showCancelButton: true,
																confirmButtonColor: '#F64E60'
															}"
															(confirm)="deactivateClient(row)"
														>
															<div class="icon-circle bg-danger text-center align-middle pt-info-button">
																<fa-icon icon="times-circle" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
														<a
															*ngIf="!row.activo && permissions.getPermission('30-20-24').asignado"
															class="danger edit mr-1 mrless"
															ngbTooltip="Reactivar cliente"
															[swal]="{
																title: 'Confirmación',
																text: '¿Está seguro de reactivar este cliente?',
																confirmButtonText: 'Reactivar',
																cancelButtonText: 'Cancelar',
																showCancelButton: true,
																confirmButtonColor: '#1BC5BD'
															}"
															(confirm)="reactivateClient(row)"
														>
															<div class="icon-circle bg-success text-center align-middle pt-info-button">
																<fa-icon icon="check-circle" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
														<a [routerLink]="" container="body" ngbTooltip="Detalle Documentos" class="primary edit mr-1 mrless" (click)="relatedDtes(row)" *ngIf="permissions.getPermission('30-20-26').asignado">
															<div class="icon-circle bg-info text-center align-middle pt-info-button">
																<fa-icon icon="book" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
													</div>
												</div>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
												<div class="row" style="width: 100%">
													<div class="col-12 mb-2 ml-3 text-center mt-2">
														<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="tableMobile.onFooterPage($event)"> </datatable-pager>
													</div>
													<div class="col-12 d-flex justify-content-center">
														<span class="mr-2 mt-3">Elementos por página</span>

														<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible" appendTo="body">
															<option *ngFor="let option of page.pageSizes" [value]="option"></option>
														</ng-select>
														<span class="ml-4 mt-3"> Página {{ curPage }} de {{ getTotalPages(rowCount, pageSize) }} </span>
													</div>
												</div>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>
									<!-- fin seccion tabla mobile-->
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
</div>

<ng-template #createClientModal let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Creación de Cliente</div>
				<div class="modal-wizard-desc">Ingrese los datos del nuevo cliente</div>
			</div>
			<button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<app-client-entry *ngIf="!setContractToNewClient" (sendCloseRequestEmitter)="closeCreateClientModal()" (sendNewClientRequest)="sendOnlyClientRequest($event)" (sendNewClientToContractRequest)="clientThenContractRequest($event)"></app-client-entry>

		<!-- <app-contract-entry 
            *ngIf="setContractToNewClient"
            [receivedReceptor]="selectedClient"
            (sendNewContractRequest)="sendContractRequest($event)"
            (sendCloseRequestEmitter)="closeCreateClientModal()"
            ></app-contract-entry> -->
	</div>
</ng-template>
<ng-template #editClientModal let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Edición de Cliente</div>
				<div class="modal-wizard-desc">Edite los datos del cliente actual</div>
			</div>
			<button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<app-client-entry *ngIf="selectedClient && editClientMode" [clientToEdit]="selectedClient" [editMode]="true" (sendCloseRequestEmitter)="closeEditClientModal()" (sendEditedClientRequest)="editClientRequest($event)"> </app-client-entry>
	</div>
</ng-template>
<!-- <ng-template #addContractModal let-d="dismiss" let-c="close">
    <div class="modal-lg">
        <div class="modal-header">
            <div class="modal-wizard-label">
                <div class="modal-wizard-title">Asignación de Contrato</div>
                <div class="modal-wizard-desc">Edite los datos del cliente actual</div>
            </div>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <app-contract-entry
            *ngIf="selectedClient"
            [receivedReceptor]="selectedClient"
            (sendCloseRequestEmitter)="closeAddContractModal()"
            (sendNewContractRequest)="sendContractRequest($event)"
            ></app-contract-entry>
    </div>
</ng-template> -->
<!-- <ng-template #contractListModal let-d="dismiss" let-c="close">
    <div class="modal-lg">
        <div class="modal-header">
            <div class="modal-wizard-label">
                <div class="modal-wizard-title">Lista de Contratos</div>
                <div class="modal-wizard-desc">Seleccione contrato para ver detalles o agregar otro contrato nuevo</div>
            </div>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <app-contract-list
            [contractList]="contractsFullList"
            [selectedClient]="selectedClient"
            (passEditRequestEmitter)="sendContractEditRequest($event)"
            ></app-contract-list>
        </div>
    </div>
</ng-template> -->

<ng-template #clientDetailModal let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Detalles de Cliente</div>
				<div class="modal-wizard-desc">Visualize los detalles del cliente seleccionado</div>
			</div>
			<button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<app-client-entry *ngIf="selectedClient" [clientToEdit]="selectedClient" [editMode]="false" (sendCloseRequestEmitter)="closeDetailsClient()"></app-client-entry>
		</div>
	</div>
</ng-template>

<swal #currentSwal title="Operación" text="Operación realizada" icon="info"></swal>
